<template>
    <div id="PriceRate">
        <div v-if="!isprint" style="position: fixed;width: 57px">
            <Button type="success" style="margin-bottom: 10px" v-if="!isdeit" @click="isdeit=!isdeit">编辑</Button>
            <Button type="error" style="margin-bottom: 10px" v-if="isdeit" @click="isdeit=!isdeit">保存</Button>
            <Button type="primary" @click="print">打印</Button>
        </div>
        <div class="out" :contenteditable="isdeit" style="page-break-after: always;">
            <h1 style="margin: 0px auto 10px;text-align: center">价格评分表</h1>
            <Row class="oueline">
                <div style="float: left;">项目名称：{{projectData.projectName}}({{projectData.projectFull}})</div>
            </Row>
            <Row class="oueline">
                <div style="float: left;width: 50%">招标人：{{projectData.purchaseName}}</div>
                <div>代理机构：{{projectData.agency}}</div>
            </Row>
            <Row class="oueline">
                <div style="float: left;width: 50%">开标时间：{{projectData.startTime.replace('T',' ')}}</div>
                <div>评审地点：{{projectData.bidAddress}}</div>
            </Row>
            <table v-for="(group,gindex) in  GroupList" :key="gindex" cellpadding="0" border="1" style="border: 1px solid #333333;table-layout: fixed;" class="toptable">           
                <th :colspan="group.setting.priceScoringMode=='下浮率' ? 11 : 10">{{group.groupName}}</th> 
                <tr>
                    <td colspan="2">投标单位名称（投标人）</td>
                    <td>{{group.setting.offerSetting}}</td>
                    <td v-if="group.setting.priceScoringMode=='下浮率'">投标报价</td>
                    <td>小型和微型企业产品报价</td>
                    <td>小型和微型企业产品价格扣除</td>
                    <td>价格调整</td>
                    <td>评标报价</td>
                    <td>评标基准价</td>
                    <td>价格评分权重</td>
                    <td>价格得分</td>
                </tr>    
                <tr v-for="(bidders,bIndex) in group.bidderList" :key="bIndex">
                    <td colspan="2">{{bidders.bidderName}}</td>
                    <td>{{group.setting.priceScoringMode=='下浮率'?bidders.dropRate:bidders.amount1|tofix(group.setting.priceDecimalPlaces!=null?group.setting.priceDecimalPlaces:2)|toMoney(group.setting.priceDecimalPlaces!=null?group.setting.priceDecimalPlaces:2)}}</td>
                    <td v-if="group.setting.priceScoringMode=='下浮率'">{{bidders.tenderDropRate|tofix(group.setting.priceDecimalPlaces!=null?group.setting.priceDecimalPlaces:2)}}</td>
                    <!-- 微小企业 -->
                    <td v-if="group.setting.priceScoringMode=='下浮率'">{{bidders.microAmount/100|tofix(group.setting.priceDecimalPlaces!=null?group.setting.priceDecimalPlaces:2)}}</td>
                    <td v-else>{{bidders.microAmount|tofix(group.setting.priceDecimalPlaces!=null?group.setting.priceDecimalPlaces:2)}}</td>
                    <!-- 微小企业 -->
                    <td>{{bidders.microDeductionAmount|tofix(group.setting.priceDecimalPlaces!=null?group.setting.priceDecimalPlaces:2)}}</td>
                    <td>{{bidders.adjustmentAmount|tofix(group.setting.priceDecimalPlaces!=null?group.setting.priceDecimalPlaces:2)}}</td>
                    <!-- 评标报价 -->
                    <td v-if="group.setting.priceScoringMode=='下浮率'">{{bidders.bidDropRate|toMoney(group.setting.priceDecimalPlaces!=null?group.setting.priceDecimalPlaces:2, true)}}</td>
                    <td v-else>{{group.setting.priceScoringMode=='下浮率'?bidders.bidDropRate:bidders.sumAmount|tofix(group.setting.priceDecimalPlaces!=null?group.setting.priceDecimalPlaces:2)|toMoney(group.setting.priceDecimalPlaces!=null?group.setting.priceDecimalPlaces:2)}}</td>
                    <!-- 评标报价 -->
                    <!-- 评标基准价 -->
                    <td v-if="group.setting.priceScoringMode=='下浮率'">{{bidders.basePrice|toMoney(group.setting.priceDecimalPlaces!=null?group.setting.priceDecimalPlaces:2, true)}}</td>
                    <td v-else>{{bidders.basePrice|tofix(group.setting.priceDecimalPlaces!=null?group.setting.priceDecimalPlaces:2)|toMoney(group.setting.priceDecimalPlaces!=null?group.setting.priceDecimalPlaces:2)}}</td>
                    <!-- 评标基准价 -->
                    <!-- 价格评分权重 -->
                    <td>{{group.setting.priceScale}}%</td>
                    <td>{{bidders.priceScore|tofix(group.setting.priceDecimalPlaces!=null?group.setting.priceDecimalPlaces:2)}}</td>
                </tr>           
            </table>      
            <div class="footer">
                <div style="width: 50%">全体评委签名：<span></span></div>
                <div style="float:right">评标日期：{{projectData.startTime.split('T')[0]}}</div>
            </div>      
        </div>
    </div>
</template>

<script>
    import requestUrl from '@/lib/requestUrls'
    import ajax from '@/lib/ajax'
    let thisneedle
    export default {
        name: 'PriceRate',
        data() {
            return {
                isprint: false,//控制打印显示
                isdeit: false,//控制编辑状态
                ProjectID: '',//项目id
                GroupID: '',//包组id
                projectData: {startTime:''},//项目信息
                GroupList: [],//包组信息
                fixNum: 2,//保留小数位
            }
        },
        beforeCreate(){
            thisneedle = this
        },
        created(){
            this.ProjectID = this.$route.query.projectID
            this.GroupID = this.$route.query.groupID
            this.getProjectData().then(res=>{
                if(!this.$route.query.groupID){//判断是否多包组查看
                    //组合数据后再赋值，避免渲染错误
                    let temp = this.projectData.groupDb
                    let count = 0
                    temp.forEach(group=>{
                        //获取设置信息
                        ajax.get(requestUrl.GroupSetting.GetByGroupId+'?id='+group.id).then(setting=>{
                            //获取详细得分情况
                            ajax.get(requestUrl.BidderGroupDb.GetListByGroupId,{
                                params:{
                                    groupId: group.id,
                                    sorting: 'sorting',
                                    filter: "status1=true"
                                }
                            }).then(bidders=>{
                                this.$set(group,'setting',setting.data.result)
                                //投标人信息
                                this.$set(group,'bidderList',bidders.data.result.items)
                                count += 1
                                if(count==temp.length){
                                    this.GroupList = temp
                                }
                            })
                        })
                    })
                }else{
                    let temp = {}
                    //获取设置信息
                    ajax.get(requestUrl.GroupSetting.GetByGroupId+'?id='+this.$route.query.groupID).then(setting=>{
                        //获取详细得分情况
                        ajax.get(requestUrl.BidderGroupDb.GetListByGroupId,{
                            params:{
                                groupId: this.$route.query.groupID,
                                sorting: 'sorting',
                                filter: "status1=true"
                            }
                        }).then(bidders=>{
                            this.$set(temp,'groupName',...this.projectData.groupDb.filter(name=>{return name.id==this.$route.query.groupID}).map(na=>{return na.groupName}))
                            this.$set(temp,'setting',setting.data.result)
                            //投标人信息
                            this.$set(temp,'bidderList',bidders.data.result.items)
                            this.GroupList = [temp]                            
                        })
                    })
                }
            })
        },
        methods:{
            async getProjectData(){//获取包组信息
                let res = await ajax.get(requestUrl.ProjectDb.GetById,{
                    params:{
                        id: this.$route.query.projectID
                    }
                })
                if(res.data.success){
                    this.projectData = res.data.result
                }
                return
            },
            print(){
                this.isprint = true
                this.$nextTick(res=>{
                    window.print()
                    this.isprint = false 
                })
            },
        },
        filters:{
            tofix(num,place=thisneedle.fixNum) {
                if(num!=null){
                    return num.toFixed(place)
                }else{
                    return (0).toFixed(place)
                }
            },
            toMoney(num,place=thisneedle.fixNum,unplace=false) {
                if (!num) {
                    let result = '0.'
                    for (let i = 0; i < place; i++) {
                        result += '0'
                    }
                    return result
                }
                if (num) {
                    if (isNaN(num)) {
                        alert("金额中含有不能识别的字符");
                        return;
                    }
                    num = typeof num == "string" ? parseFloat(num) : num; //判断是否是字符串如果是字符串转成数字
                    if (!unplace) { // 不做tofix处理
                        num = num.toFixed(place); //保留两位
                    } else {
                        num = num.toString()
                    }
                    num = `${parseFloat(num.split('.')[0]).toLocaleString()}${num.split('.')[1] ? '.' + num.split('.')[1] : ''}`
                    return num; //返回的是字符串23,245.12保留2位小数
                } else {
                    return (num = null);
                }
            }
            // toMoney(num) {
            //     if (!num) {
            //         return "0.00";
            //     }
            //     if (num) {
            //         if (isNaN(num)) {
            //             alert("金额中含有不能识别的字符");
            //             return;
            //         }
            //         num = typeof num == "string" ? parseFloat(num) : num; //判断是否是字符串如果是字符串转成数字
            //         num = num.toFixed(2); //保留两位
            //         num = parseFloat(num); //转成数字
            //         num = num.toLocaleString(); //转成金额显示模式
            //         //判断是否有小数
            //         if (num.indexOf(".") == -1) {
            //             num = num + ".00";
            //         } else {
            //             num = num.split(".")[1].length < 2 ? num + "0" : num;
            //         }
            //         return num; //返回的是字符串23,245.12保留2位小数
            //     } else {
            //         return (num = null);
            //     }
            // }
        }
    }
</script>

<style lang="less">
    body{
        overflow: auto!important;
        padding-top: 1px;
        min-height: 767px;
        color: black;
    }
    @page{
        margin: 15mm 10mm 20mm 10mm
    }
    #PriceRate{
        padding-bottom: 50px;
        .oueline{
            width: 100%;
            margin: 0 auto;
            font-size: 13px;
            line-height: 30px;
        }
        .out{
            width: 90%;
            margin: 0px auto;
            .toptable{
                width: 100%!important;
                border-collapse:collapse;
                width: max-content;
                margin: 5px 0;
                min-width: 100%;
                line-height: 25px;
                font-family: MicrosoftYaHei;
                font-size: 13px;
                color: #333333;
                text-align: center;
                th,td{
                    padding: 1px
                }
            }
            .innertable{
                border: none;
                width: 100%!important;
                border-collapse:collapse;
                width: max-content;
                min-width: 100%;
                line-height: 25px;
                font-family: MicrosoftYaHei;
                font-size: 13px;
                color: #333333;
                text-align: center;
                th{
                    text-align: left;
                    padding: 2px;
                }
                td{
                    padding: 2px
                }
            }
        }
        .footer{
            width: 100%;
            margin: 30px auto 0 auto;
            font-size: 15px;
            line-height: 30px;
            div{
                display: inline-block;
                span{
                    width: 60%;
                    border-bottom: 1px solid;
                    display: inline-block;
                    vertical-align: sub;
                }
            }
        }
    }
</style>